// ABOUTME: General-settings row for offering pickup (afhalen) at webshop checkout.
// ABOUTME: The seeded Pickup shipper is hidden from the shipper overview, so its checkout settings open from here.

import { useState } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "../../theme/text/Text";
import Shbutton from "../../theme/buttons/Shbutton";
import { useGetShippersSelectQuery } from "../../../newapi/shipper/shipperSlice";
import SpShipperDetails from "../Sidepanels/SpShipperDetails/SpShipperDetails";

const PickupCheckoutSetting = ({ settings }) => {
    const { t } = useTranslation();
    const [isExtended, setIsExtended] = useState(false);

    const shippingOptionsEnabled = settings?.find(s => s.key === "shipping_options_enabled")?.value === "true";
    const { data: shippers } = useGetShippersSelectQuery({}, { skip: !shippingOptionsEnabled });
    const pickupShipper = shippers?.find(shipper => shipper.type === "pickup");

    if (!shippingOptionsEnabled || !pickupShipper) return null;

    return (
        <>
            <Box sx={{ width: 1, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 4 }}>
                <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                    <Text semibold>{t("pickup_checkout_title")}</Text>
                    <Text light>{t("pickup_checkout_subtitle")}</Text>
                </Box>
                <Shbutton variant="outlined" color="primary" onClick={() => setIsExtended(true)}>{t("edit")}</Shbutton>
            </Box>
            {isExtended && (
                <SpShipperDetails
                    shipperId={pickupShipper.id}
                    checkoutOnly
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                />
            )}
        </>
    );
};

export default PickupCheckoutSetting;
